import React from 'react';

import './banner.less';
import i18n from "../../i18n";

export default function Banner(prop) {
    return (
        <>
            {prop.banner === 1 && <div className="banner banner--left">
                <div className="banner__content">
                    <p>{i18n.t('components.Banner.googlePlayStore.text.1')}</p>
                    <p className="banner__text-accent"><span>{i18n.t('components.Banner.googlePlayStore.text.2')}</span> {i18n.t('components.Banner.googlePlayStore.text.3')}</p>
                </div>
                <div className="banner__image banner__image--bg">
                    <img src="/img/app-link-image.svg" width="325" height="300" alt="app-link"/>
                    <a className="banner__app-link" href='https://play.google.com/store/apps/details?id=com.uvezem&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                       target="_blank" rel="noopener noreferrer">
                        <span dangerouslySetInnerHTML={{__html: i18n.t('components.Banner.googlePlayStore.link')}}/>
                        <img alt='Доступно в Google Play' src='/img/googleplaystore.png' width={173}/>
                    </a>
                </div>
            </div>}
            {prop.banner === 2 && <div className="banner banner--reverse  banner--right">
                <div className="banner__content banner__content--reverse">
                    <p>{i18n.t('components.Banner.telegram.text.1')}</p>
                    <p className="banner__text-accent">{i18n.t('components.Banner.telegram.text.2')} <span>{i18n.t('components.Banner.telegram.text.3')}</span></p>
                </div>
                <div className="banner__image">
                    <img src="/img/maxQr2.png" alt="app-link"/>
                </div>
            </div>}
        </>
    );
}
